import { BaseMapper } from '@ps/utils';
import type {
  RateCardPricing,
  RateCards,
  RateCardType,
} from '@ps/survey-utils';

import type { RateCardsDto, RateCardTypeDto } from '../dtos/rate-cards.dto';

export class RateCardsMapper extends BaseMapper<RateCardsDto, RateCards> {
  public fromDto(dto: RateCardsDto): RateCards {
    return {
      // The backend omits this entirely when the buyer's PurePrice V2
      // setting is off, unlike defaultRateCard, which is always sent.
      purePriceRateCard: dto.purePriceRateCard
        ? this._fromRateCardTypeDto(dto.purePriceRateCard, 'pureprice')
        : undefined,
      defaultRateCard: this._fromRateCardTypeDto(
        dto.defaultRateCard,
        'default',
      ),
    };
  }

  private _fromRateCardTypeDto(
    dto: RateCardTypeDto,
    type: RateCardType,
  ): RateCardPricing {
    return {
      type,
      suppliers: dto.suppliers.map((supplier) => ({
        id: supplier.id,
        cpi: supplier.cpi,
      })),
    };
  }
}
